(function() {
    'use strict';

    angular
        .module('app.organizadores')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/organizadores',
                config: {
                    templateUrl: 'app/organizadores/organizadores.html',
                    controller: 'Organizadores',
                    controllerAs: 'vm',
                    title: 'Organizadores',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/editar-organizador/:id?',
                config: {
                    templateUrl: 'app/organizadores/editarOrganizador.html',
                    controller: 'EditarOrganizador',
                    controllerAs: 'vm',
                    title: 'EditarOrganizador',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            }
        ];
    }
})();
